// extracted by mini-css-extract-plugin
export default {"picture":"PatternWinners_picture__evig9","winners":"PatternWinners_winners__usS5g"};